// "use client";

import nookies from 'nookies';
import { LocationDetails } from '../state-stores/locationStore';

export function getCookiesLocationDetails() {
  const { locationDetails: locationDetailsCookieStringified } = nookies.get(null);
  const locationDetailsCookie: LocationDetails = locationDetailsCookieStringified
    ? JSON.parse(locationDetailsCookieStringified)
    : undefined;

  return locationDetailsCookie;
}

export const setCurrentLoaction = ({
  details,
  location,
  name,
  city,
  country,
  province,
  street,
  zip_code,
  typeArabicName,
  typeEnglishName,
}: LocationDetails): void => {
  nookies.set(
    null,
    'locationDetails',
    JSON.stringify({
      location,
      name: name,
      city: city,
      country: country,
      province: province,
      street: street,
      zip_code: zip_code,
      typeArabicName: typeArabicName,
      typeEnglishName: typeEnglishName,
      type: 3,
      details: details,
    }),
    {
      maxAge: 30 * 24 * 60 * 60,
      path: '/',
    },
  );
};
